var _defs, _metadata, _rect, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalTroUndef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.6 307.76",
    id: "svg853",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs857"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.6,
    height: 307.76,
    ry: 44.816,
    id: "rect837"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.319,
    cy: 60.73,
    r: 44.596,
    fill: "#666",
    id: "circle839"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.659,
    cy: 155.22,
    r: 44.596,
    fill: "#666",
    id: "circle841"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.229607,
    cy: 250.24271,
    r: 44.596001,
    fill: "#666666",
    id: "circle841-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalTroUndef);
export default __webpack_public_path__ + "static/media/signal_tro_undef.1b37c9af93f5c9245ccdc13b1a5f2ea7.svg";
export { ForwardRef as ReactComponent };